export default __webpack_public_path__ + "static/media/V180MANA3.af05bc7c.pdf";